import React, { useState, useEffect, useRef } from 'react';

import family3bed from '../assets/kingsize.png';
import kingsize from '../assets/kingsize2.png';
import kingsizeSuperior from '../assets/kingsize+superior.png';
const rooms = [
  {
    name: 'King Suite',
    badge: 'Superior',
    img: kingsizeSuperior,
    desc: 'King-size bed + single bed. Spacious and ideal for families or small groups.',
    capacity: '3–4 Guests',
    count: '6 Rooms',
    detail:
      'Our most popular room. A plush king-size bed and a comfortable single make it perfect for families. Full AC, premium linen, private bathroom with hot geyser, and complimentary Wi-Fi.',
  },

  {
    name: 'King Deluxe',
    badge: 'Superior',
    img: kingsize,
    desc:'King-size bed. Refined and serene — ideal for couples and business travellers.',
    capacity: '2–3 Guests',
    count: '4 Rooms',
    detail:
      'Refined and calm. A luxurious king-size bed with premium linens, full AC, en-suite bathroom with hot water geyser, and high-speed Wi-Fi.',
  },

  {
    name: 'Family Suite',
    badge: 'Superior',
    img: family3bed,
    desc:
      'Multiple beds across a generous layout. The ideal choice for larger families.',
    capacity: '5–6 Guests',
    count: '2 Rooms',
    detail:
      'Our grandest space. Multiple beds, expansive layout, full AC, attached bathroom with hot geyser, and ample storage.',
  },
];

function ImageWithFallback({ src, alt }) {
  const [error, setError] = useState(false);

  if (!src || error) {
    return (
      <div
        style={{
          width: '100%',
          height: '100%',
          minHeight: '280px',
          background: '#e5dccf',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#1B2F6E',
          fontFamily: "'Jost',sans-serif",
          fontSize: '.78rem',
          letterSpacing: '2px',
          textTransform: 'uppercase',
        }}
      >
        Place image here
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      loading="lazy"
      onError={() => setError(true)}
    />
  );
}

export default function Rooms() {
  const [open, setOpen] = useState(null);
  const ref = useRef(null);

  useEffect(() => {
    if (!ref.current) return;

    ref.current.style.opacity = '0';
    ref.current.style.transform = 'translateY(28px)';

    const obs = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting) {
          e.target.style.transition =
            'opacity .9s ease, transform .9s ease';

          e.target.style.opacity = '1';
          e.target.style.transform = 'none';
        }
      },
      { threshold: 0.08 }
    );

    obs.observe(ref.current);

    return () => obs.disconnect();
  }, []);

  const go = (id) => {
    document
      .getElementById(id)
      ?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      <style>{`
        .room-card{
          overflow:hidden;
          border:1px solid rgba(201,168,76,0.22);
          background:#fff;
          transition:
            transform .45s ease,
            box-shadow .45s ease,
            border-color .45s ease;
          cursor:pointer;
          position:relative;
        }

        .room-card:hover{
          transform:translateY(-7px);
          box-shadow:0 22px 55px rgba(42,31,14,0.14);
          border-color:rgba(201,168,76,0.4);
        }

        .room-img{
          overflow:hidden;
          aspect-ratio:4/3;
          position:relative;
          background:#ece3d4;
        }

        .room-img img{
          width:100%;
          height:100%;
          object-fit:cover;
          display:block;
          transition:
            transform 1s cubic-bezier(.22,1,.36,1),
            filter .6s ease;
        }

        .room-card:hover .room-img img{
          transform:scale(1.07);
          filter:saturate(1.05);
        }

        .room-overlay{
          position:absolute;
          inset:0;
          background:
            linear-gradient(
              to top,
              rgba(10,18,45,.58),
              transparent 50%
            );
          opacity:.9;
          transition:opacity .4s ease;
        }

        .room-card:hover .room-overlay{
          opacity:1;
        }

        .room-expand{
          overflow:hidden;
          max-height:0;
          transition:max-height .55s cubic-bezier(.22,1,.36,1);
          background:#F8F1DC;
        }

        .room-expand.open{
          max-height:240px;
        }

        .room-enq-btn{
          background:#C9A84C;
          color:#0F1D48;
          font-family:'Jost',sans-serif;
          font-size:.58rem;
          letter-spacing:3px;
          text-transform:uppercase;
          padding:.7rem 1.4rem;
          border:none;
          cursor:pointer;
          font-weight:600;
          transition:all .35s ease;
          margin-top:1.2rem;
        }

        .room-enq-btn:hover{
          background:#E8C97A;
          transform:translateY(-2px);
        }

        .room-badge{
          display:inline-block;
          background:#C9A84C;
          color:#0F1D48;
          font-family:'Jost',sans-serif;
          font-size:.5rem;
          letter-spacing:3px;
          text-transform:uppercase;
          padding:.3rem .9rem;
          margin-bottom:.9rem;
          font-weight:600;
        }

        .room-meta{
          display:flex;
          justify-content:space-between;
          align-items:center;
          padding-top:1rem;
          border-top:1px solid rgba(201,168,76,0.18);
        }

        @media(max-width:860px){

          .rooms-grid{
            grid-template-columns:1fr !important;
          }

          .rooms-section{
            padding:5.5rem 1.3rem !important;
          }

          .room-expand.open{
            max-height:320px;
          }
        }
      `}</style>

      <section
        id="rooms"
        className="rooms-section"
        style={{
          padding: '7rem 3rem',
          background: '#E8D9C4',
        }}
      >
        <div style={{ maxWidth: '1120px', margin: '0 auto' }}>
          {/* HEADER */}

          <div
            style={{
              textAlign: 'center',
              marginBottom: '3.8rem',
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '.8rem',
                justifyContent: 'center',
                marginBottom: '1rem',
              }}
            >
              <div
                style={{
                  width: '32px',
                  height: '1px',
                  background: '#C9A84C',
                }}
              />

              <div
                style={{
                  width: '5px',
                  height: '5px',
                  background: '#C9A84C',
                  transform: 'rotate(45deg)',
                }}
              />

              <div
                style={{
                  width: '32px',
                  height: '1px',
                  background: '#C9A84C',
                }}
              />
            </div>

            <p
              style={{
                fontFamily: "'Jost',sans-serif",
                fontSize: '.58rem',
                letterSpacing: '5px',
                textTransform: 'uppercase',
                color: '#1B2F6E',
                marginBottom: '.7rem',
              }}
            >
              Accommodations
            </p>

            <h2
              style={{
                fontFamily: "'Cinzel',serif",
                fontSize: 'clamp(2rem,4vw,3rem)',
                color: '#1B2F6E',
                marginBottom: '.4rem',
                fontWeight: 500,
              }}
            >
              Our Superior Rooms
            </h2>

            <p
              style={{
                fontFamily: "'Cormorant',serif",
                fontSize: 'clamp(1.15rem,2vw,1.5rem)',
                fontStyle: 'italic',
                color: '#C9A84C',
                marginBottom: '1rem',
              }}
            >
              All 12 rooms thoughtfully appointed
            </p>

            <p
              style={{
                fontFamily: "'EB Garamond',serif",
                fontSize: '1rem',
                lineHeight: 1.9,
                color: 'rgba(42,31,14,0.65)',
                maxWidth: '560px',
                margin: '0 auto',
              }}
            >
              Every room is Superior category — spacious,
              fully air-conditioned, and furnished for a
              restful premium experience.
            </p>
          </div>

          {/* GRID */}

          <div
            ref={ref}
            className="rooms-grid"
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(3,1fr)',
              gap: '2rem',
            }}
          >
            {rooms.map((r, i) => (
              <div
                key={r.name}
                className="room-card"
                onClick={() =>
                  setOpen(open === i ? null : i)
                }
              >
                {/* IMAGE */}

                <div className="room-img">
                  <ImageWithFallback
                    src={r.img}
                    alt={r.name}
                  />

                  <div className="room-overlay" />

                  {/* capacity badge */}

                  <div
                    style={{
                      position: 'absolute',
                      bottom: '1rem',
                      left: '1rem',

                      background:
                        'rgba(15,29,72,.75)',

                      backdropFilter: 'blur(8px)',

                      color: '#F2E8D9',

                      padding: '.45rem .85rem',

                      fontFamily:
                        "'Jost',sans-serif",

                      fontSize: '.52rem',
                      letterSpacing: '2px',
                      textTransform: 'uppercase',
                    }}
                  >
                    {r.capacity}
                  </div>
                </div>

                {/* CONTENT */}

                <div
                  style={{
                    padding: '1.7rem 1.5rem',
                    background: '#fff',
                  }}
                >
                  {/* <div className="room-badge">
                    {r.badge}
                  </div> */}

                  <h3
                    style={{
                      fontFamily: "'Cinzel',serif",
                      fontSize: '1.2rem',
                      color: '#1B2F6E',
                      marginBottom: '.55rem',
                      fontWeight: 500,
                    }}
                  >
                    {r.name}
                  </h3>

                  <p
                    style={{
                      fontFamily:
                        "'EB Garamond',serif",
                      fontSize: '.97rem',
                      lineHeight: 1.8,
                      color:
                        'rgba(42,31,14,0.64)',
                      marginBottom: '1rem',
                    }}
                  >
                    {r.desc}
                  </p>

                  <div className="room-meta">
                    <span
                      style={{
                        fontFamily:
                          "'Cormorant',serif",
                        fontSize: '1rem',
                        color:
                          'rgba(92,74,48,0.55)',
                        fontStyle: 'italic',
                      }}
                    >
                      {r.count}
                    </span>

                    <span
                      style={{
                        fontFamily:
                          "'Jost',sans-serif",
                        fontSize: '.58rem',
                        letterSpacing: '2px',
                        color: '#C9A84C',
                        textTransform: 'uppercase',
                      }}
                    >
                      Tap to Explore
                    </span>
                  </div>
                </div>

                {/* EXPAND */}

                <div
                  className={`room-expand ${
                    open === i ? ' open' : ''
                  }`}
                >
                  <div
                    style={{
                      padding: '1.35rem 1.5rem',
                    }}
                  >
                    <p
                      style={{
                        fontFamily:
                          "'EB Garamond',serif",
                        fontSize: '.96rem',
                        lineHeight: 1.85,
                        color:
                          'rgba(42,31,14,0.72)',
                      }}
                    >
                      {r.detail}
                    </p>

                    <button
                      className="room-enq-btn"
                      onClick={(e) => {
                        e.stopPropagation();
                        go('contact');
                      }}
                    >
                      Enquire Now →
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}